/* ============================================================
   Footer custom — pointer-follow blob.
   Cada panel del footer custom tiene su propio blob interactivo
   que sigue al cursor con easing 1/20 (calcado del componente
   React de Aceternity).
   Soporta múltiples instancias (querySelectorAll).

   20 jul: el bucle de animación corría en bucle infinito a 60fps en
   TODAS las páginas, también en móvil (donde el efecto depende del ratón
   y por tanto no se ve nunca) y con "reducir movimiento" activado.
   Ahora: no arranca en táctil ni con reduced-motion, y el rAF se detiene
   solo en cuanto el blob converge, relanzándose en el siguiente mousemove.
============================================================ */
(function () {
  'use strict';

  function initPanel(panel) {
    var blob = panel.querySelector('.footer-custom__pointer');
    if (!blob) return;

    if (window.matchMedia &&
        (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
         window.matchMedia('(hover: none)').matches)) return;

    var curX = 0, curY = 0, tgX = 0, tgY = 0, raf = null;

    function tick() {
      var dx = tgX - curX, dy = tgY - curY;
      curX += dx / 20;
      curY += dy / 20;
      blob.style.transform =
        'translate(' + Math.round(curX) + 'px, ' + Math.round(curY) + 'px)';
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) { raf = null; return; }
      raf = requestAnimationFrame(tick);
    }

    panel.addEventListener('mousemove', function (e) {
      var rect = panel.getBoundingClientRect();
      tgX = e.clientX - rect.left;
      tgY = e.clientY - rect.top;
      if (raf === null) raf = requestAnimationFrame(tick);
    }, { passive: true });
  }

  function init() {
    var panels = document.querySelectorAll('.footer-custom__panel');
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
    initKlaviyo();
  }

  /* ============================================================
     Klaviyo — cada alta de email lleva nombre propio para poder
     diferenciarla: newsletter entra en la lista Email List (dispara
     el welcome flow) con custom_source "Newsletter Footer (web)";
     Android NO entra en lista (no debe recibir el welcome con
     descuento iOS): consentimiento + propiedad + evento "Espera
     Android". El submit nativo de Shopify sigue su curso (keepalive).
  ============================================================ */
  function initKlaviyo() {
    var KCO = 'WTZech';
    var LIST_NEWSLETTER = 'VEynZp';
    var H = { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' };
    function kSubscribe(email, source, listId, props) {
      var p = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email, properties: props || {} } } } } } };
      if (listId) p.data.relationships = { list: { data: { type: 'list', id: listId } } };
      try { fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KCO, { method: 'POST', keepalive: true, headers: H, body: JSON.stringify(p) }).catch(function () {}); } catch (e) {}
    }
    function kEvent(email, metric, props) {
      try { fetch('https://a.klaviyo.com/client/events/?company_id=' + KCO, { method: 'POST', keepalive: true, headers: H, body: JSON.stringify({ data: { type: 'event', attributes: { properties: props || {}, metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } }) }).catch(function () {}); } catch (e) {}
    }
    var nl = document.getElementById('FooterNewsletterForm');
    if (nl) nl.addEventListener('submit', function () {
      var em = nl.querySelector('input[type="email"]');
      if (em && em.value) kSubscribe(em.value.trim(), 'Newsletter Footer (web)', LIST_NEWSLETTER, { newsletter_footer: true });
    });
    var an = document.getElementById('FooterAndroidForm');
    if (an) an.addEventListener('submit', function () {
      var em = an.querySelector('input[type="email"]');
      if (em && em.value) {
        var v = em.value.trim();
        kSubscribe(v, 'Espera Android', null, { 'Espera Android': true });
        kEvent(v, 'Espera Android', { origen: 'footer web' });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();